import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "card-highlight" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_signin_method"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-boldest m-0" }, "Highlight PDF")
  ])
], -1)
const _hoisted_4 = {
  id: "kt_account_signin_method",
  class: "collapse show"
}
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = { class: "d-flex flex-wrap align-items-center mb-8" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-boldest mb-1" }, "Upload PDF", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold text-gray-600" }, " Form ini digunakan untuk meng-upload PDF yang akan di highlight. ", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold text-gray-600 mb-4" }, " Masukan File untuk menghighlight pdf ", -1)
const _hoisted_11 = { class: "row mb-9" }
const _hoisted_12 = { class: "col-lg-3" }
const _hoisted_13 = { class: "fv-row mb-0" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "projectname",
  class: "form-label fs-6 mb-3"
}, "Filename", -1)
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "col-lg-3" }
const _hoisted_18 = { class: "fv-row mb-0" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "projectname",
  class: "form-label fs-6 mb-3"
}, "Upload File", -1)
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "col-lg-3" }
const _hoisted_23 = {
  class: "fv-row mb-0",
  style: {"margin-top":"30px"}
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  id: "fileInputButton",
  class: "btn btn-outline btn-outline-dashed btn-outline-primary btn-active-light-primary",
  onclick: "document.getElementById('fileInput').click()"
}, " Pilih File ", -1)
const _hoisted_25 = { class: "d-flex" }
const _hoisted_26 = {
  id: "kt_crawler_submit",
  type: "submit",
  ref: "submitButton1",
  class: "btn btn-primary me-2 px-6"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Submit ", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Uploading... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { class: "card mb-5 mb-xl-10" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "List Highlight PDF")
  ])
], -1)
const _hoisted_32 = { class: "card-body py-3" }
const _hoisted_33 = {
  key: 0,
  class: "badge badge-light-danger fs-7 fw-bold"
}
const _hoisted_34 = {
  key: 1,
  class: "badge badge-light-warning fs-7 fw-bold"
}
const _hoisted_35 = {
  key: 2,
  class: "badge badge-light-success fs-7 fw-bold"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-primary" })
], -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash text-danger" })
], -1)
const _hoisted_41 = [
  _hoisted_40
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              id: "kt_signin_password",
              class: _normalizeClass({ 'd-none': _ctx.FormDisplay })
            }, _hoisted_9, 2),
            _createElementVNode("div", {
              id: "kt_signin_password_edit",
              class: _normalizeClass(["flex-row-fluid", { 'd-none': !_ctx.FormDisplay }])
            }, [
              _hoisted_10,
              _createVNode(_component_Form, {
                ref: "forms",
                id: "kt_form_highlight",
                class: "form",
                onSubmit: _ctx.saveChanges1,
                "validation-schema": _ctx.validator,
                enctype: "multipart/form-data"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createVNode(_component_Field, {
                          type: "text",
                          name: "pdf",
                          modelValue: _ctx.filename,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filename) = $event)),
                          class: "form-control form-control-lg",
                          placeholder: "Filename"
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_ErrorMessage, { name: "pdf" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createVNode(_component_Field, {
                          type: "text",
                          name: "uploadfile",
                          class: "form-control form-control-lg",
                          placeholder: "PDF",
                          disabled: "",
                          modelValue: _ctx.filenamePDF,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filenamePDF) = $event))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_ErrorMessage, { name: "uploadfile" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_Field, {
                          name: "filepdf",
                          id: "fileInput",
                          type: "file",
                          style: {"display":"none"},
                          onChange: _ctx.onFileChange
                        }, null, 8, ["onChange"]),
                        _hoisted_24
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("button", _hoisted_26, _hoisted_29, 512),
                    _createElementVNode("button", {
                      id: "kt_password_cancel",
                      type: "button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.FormDisplay.value = false)),
                      class: "btn btn-color-gray-400 btn-active-light-primary px-6"
                    }, " Cancel ")
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit", "validation-schema"])
            ], 2),
            _createElementVNode("div", {
              id: "kt_upload",
              class: _normalizeClass(["ms-auto", { 'd-none': _ctx.FormDisplay }])
            }, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.FormDisplay = !_ctx.FormDisplay)),
                class: "btn btn-light fw-boldest"
              }, " Upload PDF ")
            ], 2)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _hoisted_31,
      _createElementVNode("div", _hoisted_32, [
        _createVNode(_component_Datatable, {
          "table-data": _ctx.tableData,
          "table-header": _ctx.tableHeader,
          "enable-items-per-page-dropdown": true,
          key: _ctx.tableKey,
          total: _ctx.total_data,
          "rows-per-page": _ctx.itemsPerPage,
          "current-page": _ctx.currentPage
        }, {
          "cell-filename": _withCtx(({ row: pdf }) => [
            _createTextVNode(_toDisplayString(pdf.name), 1)
          ]),
          "cell-nama_file": _withCtx(({ row: pdf }) => [
            _createTextVNode(_toDisplayString(pdf.path), 1)
          ]),
          "cell-status": _withCtx(({ row: pdf }) => [
            (pdf.status == '0')
              ? (_openBlock(), _createElementBlock("span", _hoisted_33, "Belum Di Proses"))
              : (pdf.status == '2')
                ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Sedang Di Proses"))
                : (_openBlock(), _createElementBlock("span", _hoisted_35, "Selesai"))
          ]),
          "cell-aksi": _withCtx(({ row: pdf }) => [
            _createElementVNode("button", {
              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
              onClick: ($event: any) => (_ctx.goToRoute(pdf.path))
            }, _hoisted_38, 8, _hoisted_36),
            _createElementVNode("button", {
              class: "btn btn-icon btn-bg-light btn-active-color-danger btn-sm",
              onClick: ($event: any) => (_ctx.deleteFiles(pdf._id))
            }, _hoisted_41, 8, _hoisted_39)
          ]),
          _: 1
        }, 8, ["table-data", "table-header", "total", "rows-per-page", "current-page"])
      ])
    ])
  ]))
}